<template>
    <div class="user-page">
        <div class="user-page__header">
            <div class="user-page__header-left">
                <span class="user-page__title">客户跟进记录</span>
                <span class="user-page__subtitle">共 {{ total }} 条记录</span>
            </div>
        </div>

        <div class="user-content-card">
            <div class="user-search-bar">
                <div class="user-search-main">
                    <el-input v-model="listQuery.CustomerName" placeholder="客户名称" size="mini" clearable></el-input>
                    <el-select v-model="listQuery.UserId" placeholder="负责人" size="mini" clearable>
                        <el-option v-for="item in childUserList" :key="item.Id" :label="item.NickName" :value="item.Id"></el-option>
                    </el-select>
                    <button class="user-search-btn user-search-btn--ghost" @click="reset">重置</button>
                    <button class="user-search-btn" @click="getList">查找</button>
                    <button class="user-action-btn user-action-btn--secondary" @click="openFilterDrawer">
                        <i class="el-icon-s-operation"></i> 筛选
                        <span v-if="activeFilterTags.length" class="filter-badge">{{ activeFilterTags.length }}</span>
                    </button>
                </div>
                <div class="user-search-actions"></div>
            </div>

            <div class="active-filter-bar" v-if="activeFilterTags.length">
                <el-tag v-for="tag in activeFilterTags" :key="tag.key" closable @close="removeFilterTag(tag.key)" size="small">
                    {{ tag.label }}：{{ tag.value }}
                </el-tag>
                <el-button type="text" size="mini" @click="reset">清空筛选</el-button>
            </div>

            <div class="card-grid">
                <div class="record-card" v-for="(item, index) in KhList" :key="item.Id">
                    <div class="card-header">
                        <span class="customer-name">{{ item.CustomerName || '未命名' }}</span>
                        <span class="customer-phone">{{ item.CustomerPhone }}</span>
                    </div>
                    <div class="card-persons">
                        <div class="person-item">
                            <span class="person-avatar" :class="item.UserName ? 'avatar-active' : ''">
                                {{ item.UserName ? item.UserName[0] : '?' }}
                            </span>
                            <div class="person-text">
                                <span class="person-label">归属人</span>
                                <span class="person-name">{{ item.UserName || '-' }}</span>
                            </div>
                        </div>
                        <div class="person-item">
                            <span class="person-avatar" :class="item.CreateUserName ? 'avatar-active' : ''">
                                {{ item.CreateUserName ? item.CreateUserName[0] : '?' }}
                            </span>
                            <div class="person-text">
                                <span class="person-label">创建人</span>
                                <span class="person-name">{{ item.CreateUserName || '-' }}</span>
                            </div>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <div class="card-body">
                        <div class="track-content">{{ item.TrackContent }}</div>
                    </div>
                    <el-divider></el-divider>
                    <div class="card-footer">
                        <div class="record-time">
                            <i class="el-icon-time"></i>
                            {{ item.CreateDate | formaDate('yyyy-MM-dd hh:mm:ss') }}
                        </div>

                    </div>
                </div>
            </div>

            <div v-if="!KhList.length" class="empty-state">
                <i class="el-icon-document"></i>
                <p>暂无跟进记录</p>
            </div>

            <div class="user-pagination">
                <span class="page-desc">当前第 {{ listQuery.PageIndex }} 页，共 {{ total }} 条记录</span>
                <el-pagination
                    background
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    layout="sizes, prev, pager, next"
                    :current-page.sync="listQuery.PageIndex"
                    :page-size="listQuery.PageSize"
                    :page-sizes="[10, 20, 50]"
                    :total="total"
                ></el-pagination>
            </div>
        </div>

        <!-- 筛选抽屉 -->
        <el-drawer
            title="筛选"
            :visible.sync="filterDrawerVisible"
            direction="rtl"
            size="40%"
            custom-class="followup-filter-drawer"
            :wrapper-closable="false"
            :modal="false"
            :append-to-body="false"
            :destroy-on-close="true"
        >
            <div class="drawer-filter-body">
                <div class="filter-section">
                    <div class="filter-section__title">基础信息</div>
                    <div class="filter-section__body">
                        <div class="filter-field">
                            <span class="filter-field__label">手机</span>
                            <el-input v-model="listQuery.CustomerPhone" size="mini" placeholder="请输入手机号"></el-input>
                        </div>
                        <div class="filter-field">
                            <span class="filter-field__label">联系人</span>
                            <el-input v-model="listQuery.ContactsName" size="mini" placeholder="请输入联系人"></el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer-filter-footer">
                <el-button size="mini" @click="reset">重置</el-button>
                <el-button type="primary" size="mini" @click="applyDrawerFilter">应用筛选</el-button>
            </div>
        </el-drawer>

    </div>
</template>

<script>
import { GetCustomerFollowUpPageList } from '@/api/CustomerFollowUp';
import { GetChildUserList } from '@/api/UserInfo';

export default {
    data() {
        return {
            listQuery: {
                PageIndex: 1,
                PageSize: 10
            },
            KhList: [],
            total: 0,
            listLoading: false,
            childUserList: [],
            filterDrawerVisible: false
        };
    },
    computed: {
        activeFilterTags() {
            const tags = [];
            if (this.listQuery.CustomerName) {
                tags.push({ key: 'CustomerName', label: '客户名称', value: this.listQuery.CustomerName });
            }
            if (this.listQuery.CustomerPhone) {
                tags.push({ key: 'CustomerPhone', label: '手机', value: this.listQuery.CustomerPhone });
            }
            if (this.listQuery.ContactsName) {
                tags.push({ key: 'ContactsName', label: '联系人', value: this.listQuery.ContactsName });
            }
            if (this.listQuery.UserId) {
                const item = this.childUserList.find(function(v) { return v.Id === this.listQuery.UserId; }.bind(this));
                tags.push({ key: 'UserId', label: '负责人', value: item ? item.NickName : this.listQuery.UserId });
            }
            return tags;
        }
    },
    created() {
        this.listQuery = {
            PageIndex: 1,
            PageSize: 10
        };
        this.getStartOption();
        this.getList();
    },
    methods: {
        getStartOption() {
            GetChildUserList({})
                .then((res) => {
                    this.childUserList = res.data.Data;
                })
                .catch(function() {});
        },
        getList() {
            this.listLoading = true;
            let params = Object.assign({}, this.listQuery);
            GetCustomerFollowUpPageList(params)
                .then((res) => {
                    this.listLoading = false;
                    this.KhList = res.data.Data;
                    this.total = res.data.Total;
                })
                .catch((err) => {
                    this.listLoading = false;
                });
        },
        handleSizeChange(val) {
            this.listQuery.PageIndex = 1;
            this.listQuery.PageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.PageIndex = val;
            this.getList();
        },
        reset() {
            this.listQuery = {
                PageIndex: 1,
                PageSize: 10
            };
            this.getList();
        },
        openFilterDrawer() {
            this.filterDrawerVisible = true;
        },
        applyDrawerFilter() {
            this.listQuery.PageIndex = 1;
            this.filterDrawerVisible = false;
            this.getList();
        },
        removeFilterTag(key) {
            this.$delete(this.listQuery, key);
            this.listQuery.PageIndex = 1;
            this.getList();
        }
    }
};
</script>

<style lang="less" scoped>
.user-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 12px 14px;
    box-sizing: border-box;
    overflow: hidden;
}

.user-page__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    .user-page__header-left {
        display: flex;
        align-items: baseline;
        gap: 10px;
    }

    .user-page__title {
        font-size: 17px;
        font-weight: 600;
        color: #303133;
    }

    .user-page__subtitle {
        font-size: 12px;
        color: #909399;
    }
}

.user-content-card {
    flex: 1;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

.user-search-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px 4px;
    flex-shrink: 0;

    .user-search-main {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;

        .el-input {
            width: 140px;
        }

        .el-select {
            width: 110px;
        }

        .el-button--mini {
            font-size: 12px;
            padding: 7px 14px;
            border-radius: 8px;
        }

        .user-search-btn {
            padding: 8px 16px;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 500;
            border: none;
            cursor: pointer;
            background: #007aff;
            color: #fff;
            transition: background 0.15s;
            line-height: 1;

            &:hover {
                background: #0071e3;
            }

            &--ghost {
                background: rgba(0, 0, 0, 0.05);
                color: #3c3c43;

                &:hover {
                    background: rgba(0, 0, 0, 0.09);
                }
            }
        }

        .user-action-btn {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            padding: 7px 14px;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 500;
            border: none;
            cursor: pointer;
            transition: all 0.15s;
            letter-spacing: -0.01em;
            white-space: nowrap;
            line-height: 1;

            &--secondary {
                background: rgba(0, 0, 0, 0.05);
                color: #3c3c43;

                &:hover {
                    background: rgba(0, 0, 0, 0.09);
                }
            }
        }

        .filter-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            border-radius: 999px;
            background: #007aff;
            color: #fff;
            font-size: 10px;
            line-height: 16px;
            margin-left: 2px;
        }
    }

    .user-search-actions {
        flex-shrink: 0;
    }
}

.active-filter-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 6px;
    padding: 2px 0;
}

.card-grid {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    overflow-y: auto;
    padding: 0;
    align-content: start;
}

.record-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 5px;
    padding: 8px;
    transition: box-shadow 0.25s;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        border-color: #e0e3e8;
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4px;

        .customer-name {
            font-size: 12px;
            font-weight: 600;
            color: #303133;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .customer-phone {
            flex-shrink: 0;
            font-size: 11px;
            color: #909399;
            margin-left: 8px;
        }
    }

    .card-persons {
        display: flex;
        gap: 8px;
        padding: 1px 0;
        margin-bottom: 2px;

        .person-item {
            display: flex;
            align-items: center;
            gap: 5px;
            flex: 1;
            min-width: 0;

            .person-avatar {
                width: 22px;
                height: 22px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                font-weight: 600;
                flex-shrink: 0;
                background: #e0e0e0;
                color: #909399;

                &.avatar-active {
                    background: #409eff;
                    color: #fff;
                }
            }

            .person-text {
                display: flex;
                flex-direction: column;
                min-width: 0;

                .person-label {
                    font-size: 10px;
                    color: #c0c4cc;
                    line-height: 1.2;
                }

                .person-name {
                    font-size: 11px;
                    color: #606266;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }

    .el-divider {
        margin: 3px 0;
    }

    .card-body {
        margin-bottom: 2px;

        .track-content {
            font-size: 12px;
            color: #606266;
            line-height: 1.6;
            word-break: break-all;
            max-height: 60px;
            overflow-y: auto;
        }
    }

    .card-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .record-time {
            font-size: 10px;
            color: #909399;

            .el-icon-time {
                margin-right: 2px;
            }
        }

        .el-button--mini {
            font-size: 11px;
            padding: 5px 10px;
        }
    }
}

.empty-state {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
    color: #c0c4cc;

    .el-icon-document {
        font-size: 32px;
        margin-bottom: 6px;
    }

    p {
        font-size: 12px;
        margin: 0;
    }
}

.user-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 8px;
    border-top: 1px solid #ebeef5;
    margin-top: 6px;
    flex-shrink: 0;

    .page-desc {
        font-size: 12px;
        color: #909399;
    }
}

// 筛选抽屉
/deep/.followup-filter-drawer {
    .el-drawer__header {
        margin-bottom: 0;
        padding: 16px 20px;
        border-bottom: 1px solid #ebeef5;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
    }

    .el-drawer__body {
        display: flex;
        flex-direction: column;
    }
}

.drawer-filter-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;

    .filter-section {
        margin-bottom: 20px;

        .filter-section__title {
            font-size: 14px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 12px;
            padding-bottom: 8px;
            border-bottom: 1px solid #f0f0f0;
        }

        .filter-section__body {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }

        .filter-field {
            display: flex;
            flex-direction: column;
            gap: 6px;

            .filter-field__label {
                font-size: 13px;
                color: #606266;
            }
        }
    }
}

.drawer-filter-footer {
    padding: 12px 20px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}


</style>
